/** ChoiceButtonGroup */
export const groupCanonicalName = 'choice-button-group';
/** A record of valid values for the choice button group direction property */
export const fsChoiceButtonGroupDirection = {
    column: 'column',
    row: 'row'
};
/** The default configuration for a choice button group */
export const fsChoiceButtonGroupDefaults = {
    compact: false,
    direction: 'row',
    itemsPerRow: 0
};
//# sourceMappingURL=ChoiceButtonGroup.js.map